module.exports = __webpack_public_path__ + "img/HIW-COVER.6ad20b56.png";